module.exports = __webpack_public_path__ + "static/img/新风风管.fd747da2.png";